import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconClipboard: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconClipboard"><Path d="M15.5 4.5H19.5V21.5H4.5V4.5H8.5M8.5 2.5H15.5V6.5H8.5V2.5Z" stroke="currentColor" strokeLinecap="square"/></CentralIconBase>;
});

export default IconClipboard;
